import React, {useEffect, useState} from 'react';
import {Footer} from '../../Donation/Components/Footer/index';
import {ThanksMessages} from '../../ThankYou/Components/ThanksMessages/index';
import {animateScroll as scroll} from 'react-scroll';

export function ThankYou() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    scroll.scrollToTop();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div>
        <img
          src="/Media/lb-donate-thank-you2.png"
          alt="Thank you for your donation"
          style={{
            width: isMobile ? '100%' : '50vw',
            height: 'auto',
            maxHeight: 680,
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto',
          }}
        />
        <ThanksMessages />
        <Footer />
      </div>
    </>
  );
}
